import React from 'react';
import { ComingSoon } from '../ComingSoon';

export const Sitemap = () => {
  return <ComingSoon title="Sitemap" />;
};
